import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-previous.png'

const PreviousBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default PreviousBtn
